import gql from 'graphql-tag';

export const GET_LENDER_ACTIVITY_BY_DEALER = gql`
  query LenderRetailActivityByDealer($input: LenderRetailActivityReportInput!) {
    lenderRetailActivity {
      byDealer(input: $input) {
        success
        error
        entity {
          dealers {
            dealerId
            dealerName
            country
            creditApps
            units
          }
          countryTotals {
            country
            creditApps
            units
          }
          totalCreditApps
          totalUnits
        }
      }
    }
  }
`;
